import { useQuery } from '@tanstack/react-query'
import apiClient from '@/apiClient'

export type SubscriptionPaymentStatus =
  | 'PENDING'
  | 'SUCCEEDED'
  | 'FAILED'
  | 'CANCELLED'

export type SubscriptionPlan =
  | 'MONTHLY_STANDARD'
  | 'YEARLY_ECO'
  | 'LIFETIME_PREMIUM'

export type SubscriptionPayment = {
  id: string
  plan: SubscriptionPlan
  amountCfa: number
  currency: string
  status: SubscriptionPaymentStatus
  createdAt: string
  paidAt?: string | null
  errorMessage?: string | null
}

export function useSubscriptionPayments(take = 10) {
  return useQuery({
    queryKey: ['subscription-payments', take],
    queryFn: async () => {
      const { data } = await apiClient.get(
        `/owners/me/billing/subscription-payments?take=${take}`
      )
      return data.items as SubscriptionPayment[]
    },
  })
}
